import React, { useState } from 'react';
import TooltipIcon from 'images/Icon_Tooltip.png';

type Props = {
  text: string;
};

const Tooltip = ({ text }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleHover = () => setIsOpen(!isOpen);

  return (
    <div className="Tooltip">
      <img
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
        className="TooltipIcon"
        src={TooltipIcon}
        alt="Tooltip"
      />
      {isOpen && <div className="TooltipText">{text}</div>}
    </div>
  );
};

export default Tooltip;
